import './index.scss'

import { AuthenticationResult, EventType } from '@azure/msal-browser'
import { init } from '@fullstory/browser'
import { LicenseInfo } from '@mui/x-license-pro'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import NotificationProvider from 'src/components/common/toastNotification/NotificationProvider'

import { App } from './App'
import { getEnvVarWithDefault } from './lib/env'
import { msalInstance } from './lib/msalInstance'
import { store } from './redux/stores/store'

// Re-exported for existing importers; the client itself is created in
// lib/msalInstance so that library code does not have to import this entry point.
export { msalInstance }

// Default to using the first account if no account is active on page load
if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  msalInstance.setActiveAccount(msalInstance.getActiveAccount())
}

// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents()

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
  const payload = event.payload as AuthenticationResult
  if (event?.eventType === EventType.LOGIN_SUCCESS && payload?.account) {
    const account = payload?.account
    msalInstance.setActiveAccount(account)
  }
})

LicenseInfo.setLicenseKey(getEnvVarWithDefault('REACT_APP_MUI_LICENSE_KEY', ''))

init({
  orgId: 'o-1DCP70-na1',
})

const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(rootElement as HTMLElement)
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <NotificationProvider>
        <App instance={msalInstance} />
      </NotificationProvider>
    </Provider>
  </BrowserRouter>
)
